export default {
  EUR: '€',
  USD: '$',
  GBP: '£',
  BRL: 'R$',
};
